import { render, staticRenderFns } from "./bilibili.vue?vue&type=template&id=a9d0286e&scoped=true&"
import script from "./bilibili.vue?vue&type=script&lang=js&"
export * from "./bilibili.vue?vue&type=script&lang=js&"
import style0 from "./bilibili.vue?vue&type=style&index=0&id=a9d0286e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d0286e",
  null
  
)

export default component.exports